import { render } from "./DobNewFormat.vue?vue&type=template&id=6bf0d543"
import script from "./DobNewFormat.vue?vue&type=script&lang=js"
export * from "./DobNewFormat.vue?vue&type=script&lang=js"

import "./DobNewFormat.vue?vue&type=style&index=0&id=6bf0d543&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/misc/DobNewFormat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf0d543"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf0d543', __exports__)) {
    console.log('reload')
    api.reload('6bf0d543', __exports__)
  }
  
  module.hot.accept("./DobNewFormat.vue?vue&type=template&id=6bf0d543", () => {
    console.log('re-render')
    api.rerender('6bf0d543', render)
  })

}


export default __exports__